import angular from 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { TranslateConfigService } from './translate-config.service';

angular.module('app-lite.internationalization', [])
  .service('translateConfigApi', downgradeInjectable(TranslateConfigService));
